import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=2e6f2d08&scoped=true&"
import script from "./Channels.vue?vue&type=script&lang=js&"
export * from "./Channels.vue?vue&type=script&lang=js&"
import style0 from "./Channels.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Channels.vue?vue&type=style&index=1&id=2e6f2d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6f2d08",
  null
  
)

export default component.exports